import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import ScreenSelect from 'components/ScreensPanelItem/components/Shared/ScreenSelect';
import { Option } from 'components/ScreensPanelItem/components/Shared/ScreenSelect/models';
import { updateSurfaceType } from 'containers/Surfaces/actions';
import { MasterScreen, ScreenMap } from 'models';
import { getScreenTypesOptions } from 'utils/screenDefinitions/screenTypes';

type Props = {
  screen: ScreenMap;
  screenDefinitions: MasterScreen.ScreenDefinitionsMap;
  disabled?: boolean;
  dataTestId?: string;
};

const ScreenType: React.FunctionComponent<Props> = ({
  screen,
  screenDefinitions,
  disabled,
  dataTestId = 'screenType',
}) => {
  const dispatch = useDispatch();
  const currentScreenDefId = (screen as ScreenMap).get('screenDefinitionId');
  const currentScreenDef = screenDefinitions.get(currentScreenDefId);
  const currentScreenType = currentScreenDef.get('defaultName');

  const handleChange = (option: Option): void => {
    const screenDefId = option.value;
    dispatch(updateSurfaceType(screen.get('id'), screenDefId));
  };

  const activeOption: Option = {
    value: currentScreenDefId,
    label: currentScreenType,
  };

  const options: Option[] = useMemo(() => getScreenTypesOptions(screenDefinitions), [screenDefinitions]);

  return (
    <ScreenSelect
      activeOption={activeOption}
      onChange={handleChange}
      options={options}
      disabled={disabled}
      dataTestId={`${dataTestId}-select`}
    />
  );
};

export default ScreenType;
